import { render, staticRenderFns } from "./EventShareItem.vue?vue&type=template&id=36de2863&scoped=true"
import script from "./EventShareItem.vue?vue&type=script&lang=ts"
export * from "./EventShareItem.vue?vue&type=script&lang=ts"
import style0 from "./EventShareItem.vue?vue&type=style&index=0&id=36de2863&prod&scoped=true&lang=css"
import style1 from "./EventShareItem.vue?vue&type=style&index=1&id=36de2863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de2863",
  null
  
)

export default component.exports